import { request } from './client';

export const apiGetCart = () => request('/cart');

export const apiAddToCart = (bookId, quantity = 1) =>
  request('/cart', { method: 'POST', body: { bookId, quantity } });

export const apiUpdateCartItem = (id, quantity) =>
  request(`/cart/${id}`, { method: 'PUT', body: { quantity } });

export const apiRemoveCartItem = (id) => request(`/cart/${id}`, { method: 'DELETE' });

export const apiClearCart = () => request('/cart/clear/all', { method: 'DELETE' });
